import { start } from './ui/start';

const app = document.getElementById('app');
if (app) start(app);
